// Dayjs locale
// Need to import locale data for dayjs, ref: https://github.com/iamkun/dayjs/issues/235
import dayjs from "dayjs";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import "dayjs/locale/ja";
import "dayjs/locale/mi";
import "dayjs/locale/ru";
import "dayjs/locale/de";
// Default Options to add to the global instance, until we replace all usages
import { defaultOptions } from "./createInstance";
import de from "./de.yml";
// Import translations
import en from "./en.yml";
import fr from "./fr.yml";
import ja from "./ja.yml";
import mi from "./mi.yml";
import ru from "./ru.yml";

// Combine into resources object
const resources = {
  en: en.en,
  fr: fr.fr,
  ja: ja.ja,
  mi: mi.mi,
  ru: ru.ru,
  de: de.de,
};

i18n
  .use(LanguageDetector) // Detects languages automatically
  .use(initReactI18next) // React binding
  .init({ ...defaultOptions, resources });

// TODO: find a way to set locale fallback for dayjs
const dayjsLocale = ["en", "ja", "mi", "ru", "de"].includes(i18n.language) ? i18n.language : "en";
dayjs.locale(dayjsLocale as "en" | "ja" | "mi" | "ru" | "de");

/** @deprecated - please use `createInstance` instead */

export default i18n;

export { createInstance, changeLanguage } from "./createInstance";
export { intlLocale } from "./intlLocale";
export { supportedLanguages } from "./supportedLanguages";
